module.exports = __webpack_public_path__ + "img/legacy_letter_final_lazy_cropped.d5f18fd9.jpg";